import React from "react";
import "materialize-css/dist/js/materialize.min.js";
import "../styles/componentHeader.css";

const ComponentHeader = (props) => {
  if (props.heading === "Awards") {
    return (
      <div id={props.heading}>
        <h3
          className="styleHeader white-text indigo pd-2"
          style={{
            "padding-bottom": "0px !important",
            "margin-bottom": "10px !important",
          }}
        >
          {props.heading}
        </h3>
      </div>
    );
  } else {
    return (
      <div id={props.heading}>
        <h3 className="styleHeader white-text indigo pd-2">{props.heading}</h3>
      </div>
    );
  }
};

export default ComponentHeader;
